// eslint-disable-next-line no-restricted-imports
import { useWallet as useAptosWallet } from "@aptos-labs/wallet-adapter-react";
import { useEffect, useRef } from "react";

import { useStores } from "@stores";
export const useExternalWallet = () => {
  const { accountStore } = useStores();
  const previousAccountRef = useRef<string | null>(null);

  const {
    account,
    connected,
    isLoading,
    disconnect,
    wallet,
    wallets,
    signMessage,
    signAndSubmitTransaction,
    notDetectedWallets,
    connect,
    network,
    changeNetwork,
  } = useAptosWallet();

  useEffect(() => {
    accountStore.setWallet({
      wallet,
      connected,
      isLoading,
      account,
      signMessage,
      signAndSubmitTransaction,
      disconnect,
      network,
      changeNetwork,
    });
  }, [accountStore, connected, isLoading, account, network, signMessage, signAndSubmitTransaction, disconnect, wallet]);

  useEffect(() => {
    const wallet = localStorage.getItem("AptosWalletName");
    if (wallet && !connected && !isLoading && connect) {
      connect(wallet);
    }
  }, [connected, connect, isLoading]);

  useEffect(() => {
    if (connected && account?.address) {
      const currentAccount = account.address.toString();

      if (previousAccountRef.current && previousAccountRef.current !== currentAccount) {
        void accountStore.disconnect();
        return;
      }

      previousAccountRef.current = currentAccount;
    } else if (!connected) {
      previousAccountRef.current = null;
    }
  }, [connected, account?.address, accountStore]);

  return {
    account,
    connected,
    isLoading,
    wallet,
    wallets,
    notDetectedWallets,
  };
};
